import { styled, Paper } from "@mui/material";

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: "center",
  border: "2px dashed #1976d2",
  cursor: "pointer",
  marginTop: theme.spacing(2),
}));

export const StyledIcon = {
  fontSize: 40,
  color: "#1976d2",
};

export const ListStyle = {
  marginTop: 8,
};

export const FileItemContainer = {
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    width: "100%",
};

export const FileNameText = {
    fontWeight: 500,
};